import { render, staticRenderFns } from "./dataRule.vue?vue&type=template&id=26710008&scoped=true&"
import script from "./dataRule.vue?vue&type=script&lang=js&"
export * from "./dataRule.vue?vue&type=script&lang=js&"
import style0 from "./dataRule.vue?vue&type=style&index=0&id=26710008&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26710008",
  null
  
)

export default component.exports